import React from 'react';
import { HerbolariaLanding } from './pages/HerbolariaLanding';
export function App() {
  return <HerbolariaLanding data-id="element-0" />;
}